import { styled } from '@mui/material'

const Constrols = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.4rem;
`

export default Constrols
